export default __webpack_public_path__ + "d2c50a59a93fe69f5e3c8f9632f018c2.png";